
import Vue from "vue";
import AppFileUpload from "../FileUploadDropAndProgress.vue";
import { getContactServiceByGroupId } from "../../utils/services/contact-services";
import { AuthService } from "../../services/auth-service";
import AppMissingModule from "@/components/common/MissingModule.vue";
import { Tier } from "../../utils/payments/tiers";
import {ContactCSVImportExistingContactHandling} from "@/utils/services/contact-service";
import { ISelectItem } from "winfakt-vue-components";
import { getEnumKeys, getEnumValueFromKey } from "@/utils/enum";

export default Vue.extend({
	data() {
		return {
			file: null as null | File,
			uploading: false,
			existingContactHandling: ContactCSVImportExistingContactHandling.UPDATE,
		};
	},
	props: {
		groupId: {
			type: Number,
			required: true
		}
	},
	computed: {
		isAllowed():boolean {
			return AuthService.wfCompany.Tier == Tier.ENTERPRISE;
		},
		allowedExtensions():string[] {
			return ["csv", "txt", "xls", "xlsx", "ods"];
		},
		existingContactHandlingItems():ISelectItem<ContactCSVImportExistingContactHandling>[]{
			return getEnumKeys(ContactCSVImportExistingContactHandling).map(k=>{
				let value =getEnumValueFromKey(ContactCSVImportExistingContactHandling, k);
				return {
					text: this.$ct(`csv-import-existing-contact-handling.${k}`),
					value,
				} as ISelectItem<ContactCSVImportExistingContactHandling>;
			});
		},
		isExcel():boolean {
			if (!this.file) return false;
			return this.file.type.toLowerCase().startsWith("application/");
		}
	},
	methods: {
		cancel() {
			this.$emit("close");

		},
		async upload() {
			if (!this.file) {
				return;
			}
			this.uploading = true;
			let contactService = getContactServiceByGroupId(this.groupId);
			try {
				if (this.isExcel){
					var job = await contactService.importContactsExcel(this.file,this.existingContactHandling);
				}else{
					var job = await contactService.importContactsCSV(this.file,this.existingContactHandling);
				}
				this.$wf.notify(this.$ct("import-started"), "info", 3000, "info-circle");
				this.$emit("job", job);
				this.$emit("close");
			} catch (err) {

			}
			this.uploading = false;
		},
	},
	components: {
		AppFileUpload,
		AppMissingModule
	},
	i18nEx: {
		componentPrefix: "components.contacts"
	}
});
